import { useMemo } from 'react';

import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

import { Job } from 'src/types/gojob';

export type JobByIdQueryResponse = {
  job?: Job;
};

export const JobByIdQuery = gql`
  query JobByIdQuery($id: ID!) {
    job(id: $id) {
      id
      shortId
      caption
      city
      weeklyHours
      postalCode
      salary {
        grossHourlyRateIncludingCP
      }
    }
  }
`;

const useQueryJobById = (id?: string) => {
  const skip = !id;
  const variables = useMemo(() => {
    return id ? { id } : undefined;
  }, [id]);

  const { data, error, loading } = useQuery<JobByIdQueryResponse>(JobByIdQuery, { skip, variables });

  return { error, loading, job: data?.job };
};

export default useQueryJobById;
